


























































import { Component, Prop, Vue, Watch, PropSync } from "vue-property-decorator";
import _, { isNumber } from "lodash";
import { DxButton } from "devextreme-vue/ui/button";
import {DxPopup, DxValidationGroup} from "devextreme-vue";
import EmailTemplateService from "@/services/email-template-service";
import DButton from '@/components/DButton/button.vue';
import DTextbox from '@/components/DTextbox/textbox.vue';
import DTextarea from '@/components/DTextarea/textarea.vue';

@Component({
  name: "TemplateEditPopup",
  components: {
    DxButton,
    DxPopup,
    DTextbox,
    DButton,
    DTextarea,
    DxValidationGroup,
  }
})
export default class extends Vue {
  @PropSync('popupOptions') public localPopupOptions: any;

  public service = EmailTemplateService;

  public template: any = {
    id: null,
    name: '',
    content: ''
  };



  async created() {


  }

  async mounted() {

  }

  onShowing() {

    if (this.localPopupOptions.edit) {
      this.template = _.clone(this.service.current);
    } else {
      this.template = {
        id: null,
        name: '',
        content: ''
      };
    }

  }


  async onSave() {

    const vg = (this.$refs['templateForm'] as any).instance;
    const result = vg.validate();
    if (result.isValid) {
      try {

        const resp = await this.service.crud.save(this.template);
        if (resp) {
          try { await this.service.data_source.reload(); } catch (e) { if (e !== 'canceled') throw e; }
          this.service.resetCurrent();
          this.onClose();
        } else {
          //
        }

      } catch (e) {
        console.error(e)
      }
    }

  }

  onClose() {
      this.localPopupOptions.visible = false;
  }


}
